<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="任务名称">
        <el-input v-model="queryForm.cronName" placeholder="请输入任务名称" style="width: 200px" size="small"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getQuartzCronjobList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resets"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addQuartzCronjob"
          >新建</el-button>
          <el-button
            type="warning"
            plain
            size="small"
            icon="el-icon-edit"
            :disabled="multipleSelection.length != 1"
            @click="editQuartzCronjob(null)"
          >修改</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteQuartzCronjob(null)"
          >删除</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span
            class="icon-box"
            @click="refreshQuartzCronjobList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
        <div class="page-content">
            <!-- 列表数据 -->
            <el-tabs v-model="tabs" v-if='groupsList.length > 0'>

                <!--添加或减少：移除或添加html结构->移除或添加监听的tabs中switch case
                    修改默认显示：tab栏默认显示tabs的值 想默认显示那个直接把下面的name替换掉
                    queryForm.orderStatus的值为默认请求的类型，空表示全部-->
                <el-tab-pane label="" name="null"></el-tab-pane>
                <el-tab-pane :label="'全部'" name="zero"></el-tab-pane>
                <!--                (${computeAuditStatus[`status_${index}`]})-->
                <el-tab-pane v-for="(item,index) in groupsList" :label="`${item}`" :name='"status_"+index'></el-tab-pane>
            </el-tabs>
            <el-table
                :data="quartzCronjobList"
                row-key="id"
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cronName"
                    label="任务名称"
                    width="180"
                    size="small"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cronExpression"
                    label="任务表达式"
                    width="180"
                    size="small"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="cronGroup"
                    label="任务分组"
                    width="180"
                    size="small"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="className"
                    label="任务类"
                    width="180"
                    size="small"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="状态"
                    width="180"
                    size="small"
                >
                    <template slot-scope="scope">
                        {{getStatus(scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="description"
                    label="描述"
                    width="180"
                    size="small"
                > </el-table-column>

                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="468"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <MgJzD :typeId="scop.row.dictType" style="margin-left: 3px;"></MgJzD>
                            <div>
                                <el-button
                                    type="text"
                                    icon="el-icon-video-play"
                                    size="small"
                                    @click="resume(scop.row.id)"
                                >启动</el-button>
                                <el-button
                                    type="text"
                                    icon="el-icon-video-pause"
                                    size="small"
                                    @click="stop(scop.row.id)"
                                >暂停</el-button>
                            </div>
                            <div @click="openCronJob(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">执行记录</span>
                            </div>
                            <div @click="checkQuartzCronjob(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editQuartzCronjob(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteQuartzCronjob(scop.row.id)">
                                <Icon
                                    size="16"
                                    style="color: red"
                                >
                                    <Delete24Regular />
                                </Icon>
                                <span
                                    class="operation-label"
                                    style="color: red"
                                >删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
        </div>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog
        :title="quartzCronjobStates[quartzCronjobState]"
        :visible.sync="showDialog"
        width="60%"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="quartzCronjob"
            ref="quartzCronjobForm"
            :rules="rules"
            label-width="80px"
            size="small"
          >
            <el-form-item
              label="任务名称"
              prop="cronName"
            >
              <el-input
                size="small"
                v-model="quartzCronjob.cronName"
                :disabled="quartzCronjobState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="表达式"
              prop="cronExpression"
            >
              <el-input
                size="small"
                v-model="quartzCronjob.cronExpression"
                :disabled="quartzCronjobState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="任务分组"
              prop="cronGroup"
            >
              <el-input
                size="small"
                v-model="quartzCronjob.cronGroup"
                :disabled="quartzCronjobState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="任务类"
              prop="className"
            >
              <el-input
                size="small"
                v-model="quartzCronjob.className"
                :disabled="quartzCronjobState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="描述"
              prop="description"
            >
              <el-input
                size="small"
                type="textarea"
                :row="3"
                v-model="quartzCronjob.description"
                :disabled="quartzCronjobState == 'check'"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="状态"
              prop="status"
            >
              <el-select
                style="width: 175px"
                v-model="quartzCronjob.status"
                :disabled="quartzCronjobState == 'check'"
              >
                <el-option
                  v-for="status in statusList"
                  :key="status.key"
                  :label="status.value"
                  :value="status.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="字典类型"
              prop="dictType"
            >
              <el-input
                size="small"
                style="width: 175px"
                v-model="quartzCronjob.dictType"
                :disabled="quartzCronjobState == 'check'"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="quartzCronjobState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
      <el-drawer title="执行记录" :visible.sync="showRecordDialog" direction="rtl" size="70%"
                 :before-close="closeCronJob">
          <QuartzCronjobExecute ref="quartzCronjobRecord" />
      </el-drawer>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlace.vue';
import QuartzCronjobExecute from '@/components/system/QuartzCronjobExecute.vue';
export default {
    components: {
        QuartzCronjobExecute,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
    watch: {
        tabs(val){
            // switch (val) {
            if(val == 'zero'){
                this.queryForm.cronGroup = '';
                this.currentPage = 1;
                this.getQuartzCronjobList()
                return
            }
            for (let i = 0; i < this.groupsList.length; i++) {
                if(val == 'status_'+i){
                    this.queryForm.cronGroup = this.groupsList[i];
                    this.currentPage = 1;
                    this.getQuartzCronjobList();
                    break;
                }
            }
        },
    },
    data() {
        return {
            queryForm: {
                cronName: '', //
                cronGroup: '',
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            quartzCronjobState: 'add',
            quartzCronjobStates: {
                add: '新建任务',
                check: '查看任务',
                edit: '修改任务'
            },

            multipleSelection: [],
            quartzCronjobList: [],
            quartzCronjob: {
                id: '', //
                cronName: '', //任务名称
                cronExpression: '', //任务表达式
                cronGroup: '', //任务分组
                className: '', //任务类
                description: '', //描述
                status: '', //状态，1正常，0禁用
                dictType: '',
            },
            btnLoading: false,
            statusList: [],
            showRecordDialog: false,
            rules: {
                cronName: [{ required: true, message: '任务名称不能为空', trigger: 'blur' }],
                cronExpression: [{ required: true, message: '任务表达式不能为空', trigger: 'blur' }],
                cronGroup: [{ required: true, message: '任务分组不能为空', trigger: 'blur' }],
                className: [{ required: true, message: '任务类名不能为空', trigger: 'blur' }],
                // description: [{ required: true, message: '不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
                // dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }]
            },
            groupsList: [],
            tabs: 'zero'
        };
    },
    created() {
        this.getQuartzCronjobList();
        this.getStatusList();
        this.getAllGroups();
    },
    methods: {
        //启动定时任务
        resume(id) {
            this.$confirm('确定启动所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    get(`/quartz/cronjob/resume`, { id }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetQuartzCronjobList();
                            this.getQuartzCronjobList();
                        }
                    });
                })
                .catch(() => {});
        },
        //暂停定时任务
        stop(id) {
            this.$confirm('确定暂定所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    get(`/quartz/cronjob/stop`, { id }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetQuartzCronjobList();
                            this.getQuartzCronjobList();
                        }
                    });
                })
                .catch(() => {});
        },
        // 获取所有分组
        getAllGroups() {
            get("/quartz/cronjob/getAllGroups").then((res) => {
                if (res.success) {
                    this.groupsList = res.list;
                }
            })
        },
        getStatus(status) {
            for (const index in this.statusList) {
                if (this.statusList[index].key == status) {
                    return this.statusList[index].value;
                }
            }
        },
        openCronJob(id){
            this.showRecordDialog = true
            this.$nextTick(()=>{
                this.$refs.quartzCronjobRecord.init(id)
            })
        },
        closeCronJob(){
            this.showRecordDialog = false
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetQuartzCronjobList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.quartzCronjobList = [];
        },
        resetDialog() {
            this.quartzCronjobState = 'add';
            this.showDialog = false;
            this.quartzCronjob = {
                id: '', //
                cronName: '', //
                cronExpression: '', //
                cronGroup: '', //
                className: '', //
                deion: '', //
                status: '', //状态，1正常，0禁用
                createUserId: '', //
                updateUserId: '', //
                createTime: '', //添加时间
                updateTime: '', //修改时间
                deleteFlag: '', //是否删除，1已删除，0正常
                dictType: ''
            };
            this.getQuartzCronjobList();
        },
        resets() {
            this.queryForm = {
                id: '', //
                cronName: '', //
                cronExpression: '', //
                cronGroup: '', //
                className: '', //
                deion: '', //
                status: '', //状态，1正常，0禁用
                createUserId: '', //
                updateUserId: '', //
                createTime: '', //添加时间
                updateTime: '', //修改时间
                deleteFlag: '', //是否删除，1已删除，0正常
                dictType: ''
            };
            this.getQuartzCronjobList();
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.quartzCronjobState == 'add') {
                this.$refs.quartzCronjobForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/quartz/cronjob/add`, { ...this.quartzCronjob }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetQuartzCronjobList();
                                this.resetDialog();
                                this.getQuartzCronjobList();
                            }
                        });
                    }
                });
            } else if (this.quartzCronjobState == 'edit') {
                this.$refs.quartzCronjobForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/quartz/cronjob/edit`, { ...this.quartzCronjob }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetQuartzCronjobList();
                                this.resetDialog();
                                this.getQuartzCronjobList();
                            }
                        });
                    }
                });
            }
        },
        addQuartzCronjob() {
            (this.quartzCronjob = {}), (this.showDialog = true);
            this.quartzCronjobState = 'add';
        },
        checkQuartzCronjob(quartzCronjobId) {
            console.log(quartzCronjobId);
            this.currentQuartzCronjobId = quartzCronjobId;

            this.getQuartzCronjobById();
            this.showDialog = true;
            this.quartzCronjobState = 'check';
        },
        editQuartzCronjob(quartzCronjobId) {
            console.log('quartzCronjob', quartzCronjobId);
            if (quartzCronjobId) {
                this.currentQuartzCronjobId = quartzCronjobId;
                this.getQuartzCronjobById();
            } else {
                this.quartzCronjob = { ...this.quartzCronjob, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.quartzCronjobState = 'edit';
        },
        deleteQuartzCronjob(quartzCronjobId) {
            let ids = '';
            if (quartzCronjobId) {
                ids = quartzCronjobId;
            } else {
                ids = this.multipleSelection.map((quartzCronjob) => quartzCronjob.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/quartz/cronjob/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetQuartzCronjobList();
                            this.getQuartzCronjobList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshQuartzCronjobList() {
            this.resetQuartzCronjobList();
            this.getQuartzCronjobList();
        },
        getQuartzCronjobList(query = {}) {
            this.loading = true;
            get(`/quartz/cronjob/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.quartzCronjobList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getQuartzCronjobById() {
            get(`/quartz/cronjob/get`, { id: this.currentQuartzCronjobId }).then((res) => {
                if (res.success) {
                    this.quartzCronjob = { ...this.quartzCronjob, ...res.quartzCronjob };
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportQuartzCronjobList() {
            this.btnLoading = true;
            exprotExcel(`/mpp/quartzcronjob/export`, this.quartzCronjob, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/quartzcronjob/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/quartzcronjob/importData`, formData);
            this.refreshQuartzCronjobList();
        },
        getStatusList() {
            get(`/mpp/utils/getEnum`, { enumType: `record_status` }).then((res) => {
                if (res.success) {
                    this.statusList = res.enumList;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getQuartzCronjobList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getQuartzCronjobList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.content{
    background-color: #fff;
    padding: 10px;
    height: 100%;
}
.page-content{
    height: 93%;
    padding: 0;
    border: 0;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
